/*
 * @Author: ruiwang
 * @Date: 2024-02-25 14:42:52
 * @Last Modified by: xiaodongyu
 * @Last Modified time: 2024-03-12 17:40:19
 */
export const options1 = [
    ['約定日 ', '202x/x/x'],
    ['ステータス', '運用中'],
    ['ファンド名', 'インドネシア・マイクロファイナンス第1号（匿名組合契約型）'],
    ['購入金額／出資金総額', '10万円/3,000万円'],
    ['各種書類', '匿名組合契約書 契約締結前交付書面 契約締結時交付書面'],
    ['運用報告書', '']
];
